<div class="form-group" [ngClass]="props.disabled ? 'disabled' : ''">
  <div class="threshold-range-slider">
    <ngx-slider [formControl]="sliderFormControl" [options]="sliderOptions"></ngx-slider>
  </div>

  <div class="progress mt-1">
    <div class="progress-bar" [ngClass]="dangerClass" [ngStyle]="{ 'width': danger + '%' }"></div>
    <div class="progress-bar bg-warning" [ngStyle]="{ 'width': warning + '%' }"></div>
    <div class="progress-bar bg-success" [ngStyle]="{ 'width': success + '%' }"></div>
  </div>
</div>
